<template>
  <div>
    <Search />
    <div style="height: 112px; width: 100%" />
    <div class="p-content firm-container">
      <div class="firm-title">常见问题</div>
      <div class="category">
        <h2>一、关于商城基本操作</h2>
        <p class="firm-item-title">1、如何登录浪潮终端优选，不登录可以下单吗？</p>
        <div class="firm-item">
          <span>答：</span>
          <p>点击商城左上角“请登录”；不登录无法下单。</p>
        </div>
        <p class="firm-item-title">2、如何新增和修改收货地址？如何设置默认地址？</p>
        <div class="firm-item">
          <span>答：</span>
          <div>
            <p><span style="font-weight:bold">新增地址：</span>点击“个人中心”-“收货地址”-“添加收货地址”，填写信息。提交订单页面，也可直接新增收货地址。</p>
            <p><span style="font-weight:bold">修改地址：</span>点击“个人中心”-“收货地址”-“我的收货地址”，如需修改地址，点击收货地址“修改”，更改信息后保存即可。</p>
            <p><span style="font-weight:bold">设置默认地址：</span>在新增地址和修改地址界面均可设置该地址为默认地址。</p>
          </div>
        </div>
        <p class="firm-item-title">3、如何查看我的订单？</p>
        <div class="firm-item">
          <span>答：</span>
          <p>点击商城顶部“我的订单”，即可查 “待付款”“待发货”、“已发货”、“已完成”状态下的所有订单信息。</p>
        </div>
        <p class="firm-item-title">4、如何付款？</p>
        <div class="firm-item">
          <span>答：</span>
          <p>商城支持对公支付宝、线下支付并上传凭证。对公支付宝快捷方便，建议开通企业支付宝，使用企业支付宝余额付款即可。企业支付宝开通操作网址：https://certifyweb.alipay.com/certify/reg/guide#/ 线下支付请上传支付凭证。</p>
        </div>
        <p class="firm-item-title">5、如何申请开票？可开什么类型的发票？如何领取发票？</p>
        <div class="firm-item">
          <span>答：</span>
          <p>在下单过程中，可以填写发票抬头、收票人邮箱等信息，发货完成即开具发票，目前平台已全面切成电子发票，发票开具后会发送到填写的收票人邮箱，请注意查收</p>
        </div>
      </div>
      <div class="category">
        <h2>二、物流及签收</h2>
        <p class="firm-item-title">1、物流查询？</p>
        <div class="firm-item">
          <span>答：</span>
          <p>【我的订单】-【详情】查看物流单号及进度。部分特殊快递尚不支持实时显示物流进度，可根据单号电话查询或联系客户查询，具体以物流信息展示为准。</p>
        </div>
        <p class="firm-item-title">2、发货及配送时间？</p>
        <div class="firm-item">
          <span>答：</span>
          <div>
            <p><span style="font-weight:bold">配送时间：</span>是指从仓库装运并运送至客户指定地点的时间。</p>
            <p>含定制化服务的商品（如：箱体等），将需要更长的发货准备时间，因此，相关产品的运送时间将会延长。</p>
            <p>浪潮部分产品涉及送装一体服务，物流商会联系客户预约确认方便送货上门并安装的时间，将需要更长的发货准备时间，因此，相关产品的送达时间将会延长，或者取决于经客户确认的方便上门时间。</p>
          </div>
        </div>
        <p class="firm-item-title">3、一般下单后多久发货？在哪里查看物流信息？</p>
        <div class="firm-item">
          <span>答：</span>
          <p>平台一般24小时内可以发货。具体发货时间及物流动态，可点击“我的订单”-“详情”进行查看。</p>
        </div>
        <p class="firm-item-title">4、商品签收后，收货时间是几天？</p>
        <div class="firm-item">
          <span>答：</span>
          <p>自商品物流状态显示为“签收”后，7天未点击“确认收货”，系统自动确认收货。</p>
        </div>
        <p class="firm-item-title">5、商品是否包邮？</p>
        <div class="firm-item">
          <span>答：</span>
          <p>LED模组类商品一次性发货金额超过20万含运费，低于20万不含运费。平台内其他商品运费请以与客服协商为主！部分偏远地区不包邮！</p>
        </div>
        <p class="firm-item-title">6、物流配送范围</p>
        <div class="firm-item">
          <span>答：</span>
          <p>物流范围覆盖全国90%的县级以上城市，部分偏远地区、特殊区域（新疆、西藏、内蒙古、甘孜、阿坝等山区、景区、特殊区域军事管制区域、港口、码头、保税区）物流无法派送，或者会产生超派费、特殊费用需要用户支付。</p>
        </div>
        <p class="firm-item-title">7、商品到货后如何签收？</p>
        <div class="firm-item">
          <span>答：</span>
          <div>
            <p><span style="font-weight:bold">为保障您的切身利益，我们在此提醒您，收到商品时请注意以下事项：</span></p>
            <p>1） 收到商品时请当场验货，检查件数、货品信息和外包装是否正确且完好。如果发现包装有破损，请您在快递单的签收栏写明“外包装破损”；如件数或货品信息不一致，请在签收栏写明不一致内容。</p>
            <p>2） 由于物流服务商不支持拆包验货，如您收货现场检查时发现商品破损、数量不符、错发、漏发等情况，请您拍照存证，在签收栏写明异常原因，现场联系客服，我们将为您进行后续货物或货款处理，包括让派送员将包裹取回站点、或者补发换货等进一步行动。</p>
            <p>3） 如您没有按以上描述操作，派送员离开后，优选平台不接受以物流损坏、漏发、错发为理由的退换货。</p>
            <p>4） 在您本人不能亲自签收的情况下，请您委托他人签收并严格按照第一项和第二项内容操作。被委托人的签收视为收货人本人签收。</p>
            <p>5） 您应当提供准确的收货地址和收货人信息并及时收货。因您或您指定收货人未履行前述义务导致订单延迟配送或无法配送，由您自行承担相应责任，平台有权停止配送并取消订单。</p>
          </div>
        </div>
      </div>
      <div class="category">
        <h2>三、售后服务</h2>
        <p class="firm-item-title">1、售后服务电话及工作时间？</p>
        <div class="firm-item">
          <span>答：</span>
          <div>
            <p><span style="font-weight:bold">客服热线：</span>400-658-6111</p>
            <p><span style="font-weight:bold">客服邮箱：</span>iitpm01@inspur.com</p>
            <p><span style="font-weight:bold">工作时间：</span>工作日 09:00-17:30</p>
          </div>
        </div>
        <p class="firm-item-title">2、如何退换货操作？</p>
        <div class="firm-item">
          <span>答：</span>
          <p>退货请在订单里点击“申请退款”，后台将进行审核，审核通过后请根据提示进行退货、退款操作。</p>
        </div>
        <p class="firm-item-title">3、退换货时间？</p>
        <div class="firm-item">
          <span>答：</span>
          <p>如果商品退货，浪潮终端优选接收到问题商品后，7日之内处理完成；
            如果商品换货，浪潮终端优选接收到问题商品后，15日之内处理完成。</p>
        </div>
        <p class="firm-item-title">4、退换货类别？</p>
        <div class="firm-item">
          <span>答：</span>
          <el-table :data="list" border>
            <el-table-column prop="category" label="退换货类别" />
            <el-table-column prop="description" label="具体描述" />
            <el-table-column prop="freight" label="是否收取往返运费" width="200" />
          </el-table>
        </div>
        <p class="firm-item-title">5、退换货说明</p>
        <div class="firm-item">
          <span>答：</span>
          <div>
            <p>浪潮终端优选所售商品均为正品优货且有正规发票。凭有效发票，所有商品都可享受生产厂家或者指定服务商全国联保服务，浪潮终端优选将严格按照国家三包政策、新消法及公司退换货政策，针对所售商品履行保修、换货和退货的义务。</p>
            <p>但发生以下情况，无法给予办理退换货：</p>
            <p>1） 任何非浪潮终端优选出售的商品（序列号不符）；</p>
            <p>2） 过保商品（超过三包保修期的商品）；</p>
            <p>3） 未经授权的维修、误用、碰撞、疏忽、滥用、进液、事故、改动、不正确的安装所造成的商品质量问题，或撕毁、涂改标贴、机器序号、防伪标记；</p>
            <p>4） 无法提供商品的发票、保修卡等三包凭证或者三包凭证信息与商品不符及被涂改的；</p>
            <p>5） 商品外包装、附件、说明书、赠品等缺失的；</p>
            <p>6） 产品已使用（质量问题除外）；</p>
            <p>7） 密封产品原包装打开，一次性封贴或胶条破损（质量问题除外）；</p>
            <p>8） 包装含防伪码的商品，防伪码被刮开；</p>
            <p>9） 其他依法不应办理退换货的。</p>
          </div>

        </div>
        <p class="firm-item-title">6、定制商品可以退货吗？</p>
        <div class="firm-item">
          <span>答：</span>
          <p>不可以，定制商品订单平台已确认，不支持退换货。</p>
        </div>
      </div>
      <div class="category">
        <h2>四、产品相关</h2>
        <p class="firm-item-title">1、商品可以定制吗？</p>
        <div class="firm-item">
          <span>答：</span>
          <p>可以，模组类等商品支持定制，具体定制细则请咨询产品经理。</p>
        </div>
        <p class="firm-item-title">2、相关产品的具体参数等事宜？</p>
        <div class="firm-item">
          <span>答：</span>
          <p>具体产品参数等事宜请联系对应售前经理。</p>
        </div>
      </div>
      <div class="category">
        <h2>五、具体业务对接人</h2>
        <div class="firm-item">
          <span>答：</span>
          <el-table :data="peopleList" border :span-method="arraySpan">
            <el-table-column prop="bigCategory" label="问题大类" />
            <el-table-column prop="scale" label="大概范围" width="540" />
            <el-table-column prop="name" label="对接人" />
            <el-table-column prop="phone" label="电话" />
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Search from '@/components/Search'
export default {
  name: 'Questions',
  components: {
    Search
  },
  beforeRouteEnter(to, from, next) {
    window.scrollTo(0, 0)
    next()
  },
  data() {
    return {
      list: [
        {
          category: '第一类：国家法律所规定的功能性故障或商品质量问题',
          description: '经由生产厂家指定或特约售后服务中心检测确认并出具检测报告，或经浪潮终端优选售后确认属于商品质量问题。',
          freight: '否'
        },
        {
          category: '第二类：到货物流损、缺件或商品描述与网站不符等非客户原因',
          description: '物流损指在运输过程中造成的损坏、漏液、破碎、性能故障，缺件指商品原装配件缺失，经售后人员核查情况属实（期间可能需要您提供快递、物流公司或该公司送货人员书面证明以及要求您提供实物照片等，以便售后人员快速做出判断并及时处理）。',
          freight: '否'
        },
        {
          category: '第三类：客户原因',
          description: '除以上两种原因之外，如客户原因导致的退换货，需保证商品及包装完好且不影响二次销售。',
          freight: '是'
        }
      ],
      columns: [
        {
          title: '问题大类',
          key: 'bigCategory'
        },
        {
          title: '大概范围',
          key: 'scale'
        },
        {
          title: '对接人',
          key: 'name'
        },
        {
          title: '电话',
          key: 'phone'
        }
      ],
      peopleList: [
        {
          bigCategory: '商城操作类',
          scale: '登录、搜索 、账号密码、下单等',
          name: '董秀云',
          phone: '18853116161'
        },
        {
          bigCategory: '投诉类',
          scale: '服务不好等',
          name: '董秀云',
          phone: '18853116161'
        },
        {
          bigCategory: '物流咨询',
          scale: '货单号、送货问题等',
          name: '王盛昌',
          phone: '13075398573'
        },
        {
          bigCategory: '售前咨询',
          scale: '渠道商、代理商咨询LED模组类产品',
          name: '姜军涛',
          phone: '15305316781'
        },
        {
          bigCategory: '售前咨询',
          scale: '工程类LED产品',
          name: '张可',
          phone: '17862989392'
        },
        {
          bigCategory: '售前咨询',
          scale: 'LED配套配件类',
          name: '张可',
          phone: '17862989392'
        },
        {
          bigCategory: '售前咨询',
          scale: 'LCD产品',
          name: '王利新',
          phone: '18511253669'
        },
        {
          bigCategory: '售前咨询',
          scale: 'LCD产品',
          name: '李晓瑜',
          phone: '18953682959'
        },
        {
          bigCategory: '售前咨询',
          scale: '智慧家居',
          name: '杨家伟',
          phone: '18002547206'
        },
        {
          bigCategory: '售前咨询',
          scale: '无线充电器',
          name: '朱瑞祺',
          phone: '13969058730'
        },
        {
          bigCategory: '售前咨询',
          scale: '手持洗衣机、消毒仪',
          name: '孙洪涛',
          phone: '13361029086'
        },
        {
          bigCategory: '售前咨询',
          scale: '音视频产品',
          name: '修耿强',
          phone: '15666453682'
        },
        {
          bigCategory: '售后咨询',
          scale: '常规售后统一400服务电话：400-658-6111，无法解决的问题400转到各个事业部',
          name: '翟肇起',
          phone: '15264347697'
        },
        {
          bigCategory: '售后咨询',
          scale: '常规售后统一400服务电话：400-658-6111，无法解决的问题400转到各个事业部',
          name: '刘梦',
          phone: '18754128926'
        }
      ]
    }
  },
  methods: {
    arraySpan({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 3) {
          return [9, 1]
        }
        if (rowIndex > 3 && rowIndex <= 11) {
          return [0, 0]
        }
        if (rowIndex === 12) {
          return [2, 1]
        }
        if (rowIndex === 13) {
          return [0, 0]
        }
      }
      if (columnIndex === 1) {
        if (rowIndex === 6) {
          return [2, 1]
        }
        if (rowIndex === 7) {
          return [0, 0]
        }
        if (rowIndex === 12) {
          return [2, 1]
        }
        if (rowIndex === 13) {
          return [0, 0]
        }
      }
      if (columnIndex === 2) {
        if (rowIndex === 4) {
          return [2, 1]
        }
        if (rowIndex === 5) {
          return [0, 0]
        }
      }
    }
  }
}
</script>

<style scoped>
.firm-container {
  padding-bottom: 50px;
  color: #000;
}
.firm-title {
  font-size: 18px;
  color: black;
  font-weight: bold;
  text-align: center;
  margin-top: 30px;
}
.firm-item-title{
  font-size: 14px;
  color: black;
  margin-top: 20px;
  line-height: 25px;
  font-weight: bold;
}
.firm-item {
  font-size: 14px;
  color: #3f3f3f;
  margin-top: 10px;
  line-height: 25px;
  display: flex;
}
.category {
  margin-top: 30px;
}
</style>
